import { environment as sharedEnv } from '@knoxpo/ui/node/environment/stage';

export const environment = {
  ...sharedEnv,
};
